import { EntitiesStore } from './entities-store.abstract';
import { HttpClient, HttpParams } from '@angular/common/http';
import { RankingItem } from 'world-archery-lib';
import { environment } from '@environments/environment';
import { tap } from 'rxjs/operators';

/**
 * WCupRanking athletes entity store
 *
 * @export
 * @class WcupRankingStore
 * @extends {EntitiesStore<RankingItem>}
 */
export class WcupRankingStore extends EntitiesStore<RankingItem> {
  constructor(http: HttpClient, dependencies:Array<any>) {
    super('WORLDCUPRANKINGS', http, dependencies);

  }
   /**
   * @Override due to required mapping
   * The method for request data
   *
   * @param {ParamsType} params
   * @param {boolean} request_more
   * @memberof EntitiesStore
   */
  getRequest(params: any, request_more: boolean) {
    this.loadingRef = true;
    this.requestMore = request_more;
    return this.http.get<{ pageInfo: any, items: Array<RankingItem> }>(environment.api_url,
      {
        params: new HttpParams({ fromObject: params as any })
          .append('content', this.endpoint_name)
          .append('v', '3')
          .append('RBP', (((this.data.length === this.pagination.totalResults) && this.data.length !== 0) ? this.pagination.totalResults :
            request_more === true ? this.pagination.resultsPerPage + 10 : 10).toString())
      }
    ).pipe(tap(next=>{
      this.data = next.items.map(item => new RankingItem(item, undefined));
      this.pagination = next.pageInfo;
      this.loadingRef = false;
      this.requestMore = false;
    }));
  }
}
